import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  standalone: false,
})
export class HomeComponent implements OnInit {
  constructor() {
    // This comment prevents husky rejection due to empty method
  }

  ngOnInit(): void {
    // This comment prevents husky rejection due to empty method
  }
}
